var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "envelope 1",
    clipPath: "url(#clip0_743_107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.91961 6.9868C2.1726 7.16533 2.93523 7.69556 4.20753 8.57722C5.47986 9.45888 6.45456 10.1377 7.13165 10.6138C7.20604 10.666 7.36409 10.7795 7.60587 10.9543C7.84769 11.1293 8.04861 11.2707 8.2085 11.3785C8.36849 11.4863 8.56192 11.6073 8.78896 11.7412C9.01592 11.8749 9.22987 11.9756 9.43076 12.0422C9.63168 12.1093 9.81768 12.1426 9.98878 12.1426H10H10.0113C10.1824 12.1426 10.3684 12.1093 10.5694 12.0422C10.7702 11.9756 10.9843 11.8748 11.2111 11.7412C11.438 11.6071 11.6314 11.4863 11.7914 11.3785C11.9514 11.2707 12.1522 11.1293 12.3941 10.9543C12.6358 10.7793 12.794 10.666 12.8684 10.6138C13.5528 10.1377 15.2941 8.92861 18.0916 6.98657C18.6347 6.60726 19.0885 6.14959 19.453 5.61384C19.8178 5.07834 20 4.51656 20 3.92882C20 3.43768 19.8232 3.01726 19.4697 2.66759C19.1163 2.31784 18.6977 2.14307 18.2142 2.14307H1.78564C1.21276 2.14307 0.771892 2.33649 0.463112 2.72333C0.154371 3.11026 0 3.59389 0 4.1742C0 4.64294 0.204681 5.15089 0.613847 5.69773C1.02297 6.24462 1.45837 6.67435 1.91961 6.9868Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.8838 8.1809C16.4436 9.83254 14.5907 11.1161 13.3259 12.0314C12.9018 12.3438 12.5578 12.5876 12.2936 12.7624C12.0294 12.9372 11.678 13.1158 11.2389 13.298C10.8 13.4805 10.391 13.5714 10.0114 13.5714H10H9.98882C9.60936 13.5714 9.20008 13.4805 8.76116 13.298C8.32225 13.1158 7.97063 12.9372 7.70649 12.7624C7.44243 12.5876 7.09827 12.3438 6.67421 12.0314C5.66969 11.2949 3.82076 10.0112 1.12735 8.1809C0.703131 7.89835 0.327388 7.57449 0 7.20996V16.0713C0 16.5627 0.174776 16.9829 0.524524 17.3326C0.874193 17.6824 1.29466 17.8573 1.78576 17.8573H18.2144C18.7054 17.8573 19.1258 17.6824 19.4755 17.3326C19.8253 16.9828 20 16.5627 20 16.0713V7.20996C19.68 7.56694 19.3081 7.89081 18.8838 8.1809Z",
    fill: "#666666"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.6cbbba1fe5351d7bb915e41c0f40fe3a.svg";
export { ForwardRef as ReactComponent };